import "@fontsource-variable/dm-sans";
import "@fontsource/dm-mono/400.css";
import "@fontsource/dm-mono/500.css";
// Italic only, with the WONK axis: the Milqit wordmark and display accents (Figma "Fraunces Light Italic").
import "@fontsource-variable/fraunces/full-italic.css";
import "./app/globals.css";

import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "react-router/dom";

import { ApiNotConfigured } from "@/components/shell/api-not-configured";
import { envProblem } from "@/lib/env";
import { readPreferences } from "@/lib/preferences";

import { Providers } from "./app/providers";
import { router } from "./app/router";

// Apply saved layout preferences before React renders so the first paint is already right.
const preferences = readPreferences();
document.documentElement.dataset.contentLayout = preferences.contentLayout;
document.documentElement.dataset.navbarStyle = preferences.navbarStyle;

const root = document.getElementById("root");
if (!root) throw new Error("Missing #root element in index.html");

createRoot(root).render(
  <StrictMode>
    {envProblem ? (
      <ApiNotConfigured problem={envProblem} />
    ) : (
      <Providers>
        <RouterProvider router={router} />
      </Providers>
    )}
  </StrictMode>,
);
